import {
  UPDATE_ACTIVITY_COUNT
} from '../constants';

export const updateActivityCounts = (counts) => {
  return {
    type: UPDATE_ACTIVITY_COUNT,
    counts
  }
}


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/actions/userActivityActions.js